import type { CourierSettlementLinesFilters } from '../../../models/settlementLinesFilters';
import { countSettlementLinesPanelFilters } from '../../../models/settlementLinesFilters';
import { SettlementLinesFiltersPanel } from './SettlementLinesFiltersPanel';
import { SettlementDownloadExcelButton } from './SettlementDownloadExcelButton';
import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { Search } from '@shared/components/ui/Search';
import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface SettlementLinesFiltersSectionProps {
  settlementId: number;
  handleSearch: (value: string) => void;
  searchTerm: string;
  filters: CourierSettlementLinesFilters;
  onFiltersChange: (next: CourierSettlementLinesFilters) => void;
  hasTeamData?: boolean;
}

/**
 * Misma composición que Orders `FiltersSection`: Search + FiltersDropdown + export Excel (icono).
 */
export const SettlementLinesFiltersSection = ({
  settlementId,
  handleSearch,
  searchTerm,
  filters,
  onFiltersChange,
  hasTeamData = false,
}: SettlementLinesFiltersSectionProps) => {
  const { t } = useTranslation('courierInvoicesModule');
  const [inputValue, setInputValue] = useState(searchTerm);

  useEffect(() => {
    setInputValue((prev) => (prev === searchTerm ? prev : searchTerm));
  }, [searchTerm]);

  const panelFiltersCount = useMemo(() => countSettlementLinesPanelFilters(filters), [filters]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSearchSubmit = () => {
    handleSearch(inputValue.trim());
  };

  return (
    <>
      <Search
        placeholder={t('settlement.table_search_placeholder')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="settlement-charge-lines-search"
        inputDataTestId="settlement-charge-lines-search-input"
      />

      <FiltersDropdown
        title={t('settlement.lines_filters.title')}
        triggerLabel={t('settlement.lines_filters.open')}
        activeFiltersCount={panelFiltersCount}
        triggerTestId="settlement-lines-filters-toggle"
      >
        <SettlementLinesFiltersPanel filters={filters} onChange={onFiltersChange} hasTeamData={hasTeamData} />
      </FiltersDropdown>

      <SettlementDownloadExcelButton settlementId={settlementId} filters={filters} />
    </>
  );
};
